import { markRaw } from 'vue';
import Store from '@app/store';
import Router from '@app/router';
import Blocks from '@app/components/Blocks';
class ModuleContainer {
    constructor() {
        /**
         * Holds an array of loaded modules
         */
        this.modules = [];
    }
    /**
     * Register the given module and
     * load all necessary resources
     *
     * @param module Module to register
     */
    register(module) {
        // Check if module is already loaded
        if (this.isModuleLoaded(module)) {
            return console.error(`Module ${module.namespace} already loaded`);
        }
        // Add routes
        if (module.routes) {
            module.routes.forEach(route => Router.addRoute(route));
        }
        // Register store
        if (module.store) {
            Store.registerModule(module.namespace.substring(module.namespace.indexOf('/') + 1), module.store);
        }
        // Register blocks
        if (module.blocks) {
            for (let blockName in module.blocks) {
                Blocks.registerBlock(blockName, module.blocks[blockName]);
            }
        }
        // Register block groups
        if (module.blockGroups) {
            for (let groupName in module.blockGroups) {
                Blocks.registerGroup(groupName, module.blockGroups[groupName]);
            }
        }
        // Add to loaded modules array
        this.modules.push(module);
        if (window.laravelDebug) {
            console.log(`📦 Module loaded [${module.namespace}]`);
        }
    }
    /**
     * Returns an array of all loaded modules
     */
    getLoadedModules() {
        return this.modules;
    }
    /**
     * Check if a given module is already loaded
     *
     * @param module Module to check
     */
    isModuleLoaded(module) {
        return this.modules.map(m => m.namespace).indexOf(module.namespace) !== -1;
    }
    /**
     * Returns an array of components
     * tagged with the given tag
     *
     * @param tag Tag to search for
     */
    getTaggedComponents(tag) {
        const components = this.modules
            .filter(module => {
            return module.taggedComponents !== undefined
                && module.taggedComponents[tag] !== undefined;
        })
            .map(module => module.taggedComponents[tag])
            .reduce((acc, val) => acc.concat(val), []);
        return markRaw(components);
    }
}
export default new ModuleContainer;
